import Vue from 'vue'
import LoginMain from './components/LoginMain'
import MainHome from './components/MainHome'
import UserGuide from './components/UserGuide'
import UserAgreement from './components/UserAgreement'
import ProjectManagement from './components/ProjectManagement'
import BatteryBalance from './components/BatteryBalance'
// import PdfView from './components/PdfView'
// import PdfTest from './components/PdfTest.vue'
import VRouter from 'vue-router'
// import { ElStep } from 'element-ui/types/step'
Vue.use(VRouter)
var router=new VRouter({
    mode:'history',
    base:"/battery-matrix",
    routes:[{
        path: "/",
        redirect: "/login"
    },{
        path:'/login',component:LoginMain
    },
    {
        path:'/diagnosis-management',component:MainHome
    },
    {
        path:'/user-guide',component:UserGuide
    },
    {
        path:'/user-agreement',component:UserAgreement
    },
    {
        path:'/project-management',component:ProjectManagement
    },
    {
        path:'/battery-balance',component:BatteryBalance
    },
    // {
    //     path:'/pdf-test',component:PdfTest
    // }
    ]
})
router.beforeEach((to, from, next) => {
    // console.log(to) // 即将要进入路由的对象
    // console.log(from) // 当前导航要离开的路由对象
    // console.log(next) // 调用next该方法，才能进入下一个路由
    // 1. 判断是不是登录或者注册页面
    // 是登录或者注册页面
    if (to.path === '/' || to.path === '/login') {
      next()
    } else {
      // 不是登录页面
      // 2. 判断 是否登录过
      let token = window.localStorage.token
      if(token){
        next()
      }
      else{
        next({path: '/'})
        // this.$message.error('请登录！')
      }
    }
  })

export default router